import type { FC } from 'react';
import { useFullscreen } from '../../CasinoGamePage.context';
import type { GameLayoutProps } from './GameLayout.types';
import styles from './GameLayout.module.scss';
export const GameLayout: FC<GameLayoutProps> = ({
  className,
  headerSection,
  gameSection,
  sideSection,
  bottomSection,
  gameContainerRef
}) => {
  const {
    isFullscreen,
    containerRef,
    notSupported
  } = useFullscreen();
  return <div className={cn(styles.root, className, {
    [styles.fullscreen]: isFullscreen,
    [styles.notSupported]: isFullscreen && notSupported
  })} ref={containerRef} data-sentry-component="GameLayout" data-sentry-source-file="GameLayout.tsx">
      <div className={styles.header}>{headerSection}</div>
      <div className={styles.game} ref={gameContainerRef}>
        {gameSection}
      </div>
      <div className={styles.side}>{sideSection}</div>
      <div className={styles.bottom}>{bottomSection}</div>
    </div>;
};